import { FormControl, FormGroup } from '@angular/forms';
import { SmallBusinessOptionType } from 'src/app/interfaces/small-business-option-type';

export class SmallBusinessOptionForm extends FormGroup<{
  id: FormControl<number | undefined>;
  VendorId: FormControl<number | undefined>;
  ExemptVendorId: FormControl<number | undefined>;
  ClientRegisteredVendorId: FormControl<number | undefined>;
  type: FormControl<SmallBusinessOptionType | undefined>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      VendorId: new FormControl<number | undefined>(undefined, {
        nonNullable: true
      }),
      ExemptVendorId: new FormControl<number | undefined>(undefined, {
        nonNullable: true
      }),
      ClientRegisteredVendorId: new FormControl<number | undefined>(undefined, {
        nonNullable: true
      }),
      type: new FormControl<SmallBusinessOptionType | undefined>(undefined, {
        nonNullable: true
      })
    });
  }
}
